shadow$provide[456] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `uniform vec3 styleColor;
uniform float styleOpacity;

vec4 getStyleColor() {
  return vec4(styleColor, styleOpacity);
}
`;

};